import { defineStore } from "pinia";
import { showError } from "src/utils/notify";

export const useNotificationDetails = defineStore("notification", {
  state: () => ({
    notificationList: [],
    loadNotification: false,
  }),
  getters: {},
  actions: {
    async getNotificationData(params) {
      try {
        let response = await this.$request.get(
          this.apiEndpoints.NOTIFICATION(params.page, params.per_page)
        );
        if (params.page == 1) {
          this.resetNotificationData();
        }
        if (response.data) {
          Array.prototype.push.apply(
            this.notificationList,
            response.data.items
          );
          this.loadNotification = true;
          this.notificationList.sort((a, b) => {
            var dateA = new Date(a.created_at.replace(" ", "T")).getTime();
            var dateB = new Date(b.created_at.replace(" ", "T")).getTime();
            return dateA < dateB ? 1 : -1;
          });
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetNotificationData() {
      this.notificationList = [];
      this.loadNotification = false;
    },
    async getGiftDetail(id, options) {
      try {
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.GIFT_DETAIL(id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_GIFT_DETAIL(id);
            break;
        }
        if (URL) {
          response = await this.$request.get(URL);
          if (response.data) {
            return response.data;
          }
          return {};
        } else {
          return {};
        }
      } catch (error) {
        showError(error.message);
      }
    },

    async trackNotificationForTypePPlus(notificationType, id) {
      try {
        if (notificationType && id) {
          console.log(
            `Call Api for track notification with type ${notificationType} and id ${id}`
          );
          await this.$request.get(
            `${this.apiEndpoints.PPLUS_NOTIFICATION_TRACK}/${notificationType}/${id}`
          );
        } else {
          console.log(
            `Can not call Api for track notification because type is ${notificationType} and id is ${id}`
          );
        }
      } catch (error) {}
    },
  },
});
